import { FormFieldV2 } from '@/components/custom/erp';
import { Label } from '@/components/ui/label';
import { FormMode } from '@/types/form';

interface ExchangeRateTabProps {
  formMode: FormMode;
}

const ExchangeRateTab: React.FC<ExchangeRateTabProps> = ({ formMode }) => {
  const isViewMode = formMode === 'view';

  return (
    <div className='max-h-[calc(100vh-150px)] overflow-y-auto'>
      <div className='p-4 md:p-6'>
        <div className='flex gap-y-8'>
          <Label className='w-40'>Sửa tỷ giá ghi sổ</Label>
          <FormFieldV2 name='tg_dd' type='checkbox' disabled={isViewMode} />
        </div>
      </div>
    </div>
  );
};

export default ExchangeRateTab;
